import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=abdeb5ac&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
import style0 from "./catalog.vue?vue&type=style&index=0&id=abdeb5ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdeb5ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abdeb5ac')) {
      api.createRecord('abdeb5ac', component.options)
    } else {
      api.reload('abdeb5ac', component.options)
    }
    module.hot.accept("./catalog.vue?vue&type=template&id=abdeb5ac&scoped=true", function () {
      api.rerender('abdeb5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/course/catalog.vue"
export default component.exports